(function () {
  if (window.HC_FUEL_TYPE_ATC_POPUP_CLICK_INIT) return;
  window.HC_FUEL_TYPE_ATC_POPUP_CLICK_INIT = true;

  window.HC_FUEL_TYPE_BY_VARIANT = window.HC_FUEL_TYPE_BY_VARIANT || {};
  const FUEL_MESSAGES = {
    'lpg': 'The Grill you added to your cart is Designed for<br><strong>LPG (Propane) Use Only</strong>.',
    'natural-gas': 'The Grill you added to your cart is Designed for<br><strong>NG (Natural Gas) Use Only</strong>.'
  };

  const confirmedButtons = new WeakSet();
  const confirmedForms = new WeakSet();

  function getFuelType(variantId) {
    if (!variantId) return '';
    return window.HC_FUEL_TYPE_BY_VARIANT[String(variantId)] || '';
  }

  function getFuelMessage(variantId) {
    const fuelType = getFuelType(variantId);
    return FUEL_MESSAGES[fuelType] || '';
  }

  function getVariantIdFromForm(form) {
    if (!form) return '';

    const formData = new FormData(form);
    const idFromFormData = formData.get('id');

    if (idFromFormData) return String(idFromFormData);

    const idInput = form.querySelector('[name="id"]');
    if (idInput && idInput.value) return String(idInput.value);

    return '';
  }

  function getVariantIdFromButton(button) {
    if (!button) return '';

    const form = button.closest('form');
    const idFromForm = getVariantIdFromForm(form);

    if (idFromForm) return idFromForm;

    const productCard = button.closest(
      '[data-product-item], [data-product-card], .product-item, .product-card, .product'
    );

    if (productCard) {
      const idInput = productCard.querySelector('[name="id"]');
      if (idInput && idInput.value) return String(idInput.value);

      const variantIdEl = productCard.querySelector('[data-variant-id]');
      if (variantIdEl && variantIdEl.dataset.variantId) {
        return String(variantIdEl.dataset.variantId);
      }
    }

    return '';
  }

  function isAddToCartButton(button) {
    if (!button) return false;

    const form = button.closest('form');
    const text = (button.textContent || button.value || '').trim().toLowerCase();

    if (form && form.action && form.action.includes('/cart/add')) return true;

    if (button.matches('[name="add"], [data-add-to-cart], [data-atc], [data-product-atc]')) {
      return true;
    }

    if (
      button.classList.contains('product-form__cart-submit') ||
      button.classList.contains('product-form__submit') ||
      button.classList.contains('add-to-cart') ||
      button.classList.contains('add-to-cart-button')
    ) {
      return true;
    }

    return text.includes('add to cart') || text.includes('add');
  }

  function ensureModal() {
    if (document.querySelector('[data-hc-fuel-popup-modal]')) return;

    const style = document.createElement('style');
    style.textContent = `
      .hc-fuel-popup-overlay {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.45);
        z-index: 999999;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
      }

      .hc-fuel-popup-box {
        width: 100%;
        max-width: 460px;
        background: #fff;
        color: #303030;
        padding: 28px 26px;
        box-shadow: 0 18px 50px rgba(0, 0, 0, 0.22);
        text-align: center;
        font-family: inherit;
      }

      .hc-fuel-popup-title {
        font-size: 20px;
        line-height: 1.3;
        margin: 0 0 14px;
        font-weight: 600;
      }

      .hc-fuel-popup-message {
        font-size: 16px;
        line-height: 1.55;
        margin: 0 0 24px;
      }

      .hc-fuel-popup-button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 140px;
        min-height: 44px;
        padding: 12px 22px;
        border: 0;
        background: #7dd2cb;
        color: #303030;
        cursor: pointer;
        font-size: 15px;
        font-weight: 600;
        font-family: inherit;
      }

      .hc-fuel-popup-button:hover {
        opacity: 0.9;
      }
    `;

    const modal = document.createElement('div');
    modal.setAttribute('data-hc-fuel-popup-modal', '');
    modal.style.display = 'none';
    modal.innerHTML = `
      <div class="hc-fuel-popup-overlay" role="dialog" aria-modal="true" aria-labelledby="hc-fuel-popup-title">
        <div class="hc-fuel-popup-box">
          <h3 class="hc-fuel-popup-title" id="hc-fuel-popup-title">Fuel Type Notice</h3>
          <p class="hc-fuel-popup-message" data-hc-fuel-popup-message></p>
          <button type="button" class="hc-fuel-popup-button" data-hc-fuel-popup-ok>OK</button>
        </div>
      </div>
    `;

    document.head.appendChild(style);
    document.body.appendChild(modal);
  }

  function showPopup(message) {
    ensureModal();

    return new Promise((resolve) => {
      const modal = document.querySelector('[data-hc-fuel-popup-modal]');
      const messageEl = modal.querySelector('[data-hc-fuel-popup-message]');
      const okButton = modal.querySelector('[data-hc-fuel-popup-ok]');

      messageEl.innerHTML = message;
      modal.style.display = 'block';

      const close = () => {
        modal.style.display = 'none';
        okButton.removeEventListener('click', close);
        resolve();
      };

      okButton.addEventListener('click', close);
      okButton.focus();
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest('button, input[type="submit"], a');

      if (!isAddToCartButton(button)) return;

      if (confirmedButtons.has(button)) {
        confirmedButtons.delete(button);
        return;
      }

      const variantId = getVariantIdFromButton(button);
      const message = getFuelMessage(variantId);

      if (!message) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      showPopup(message).then(() => {
        confirmedButtons.add(button);

        setTimeout(() => {
          confirmedButtons.delete(button);
        }, 2000);

        button.click();
      });
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;

      if (!form || !form.action || !form.action.includes('/cart/add')) return;

      if (confirmedForms.has(form)) {
        confirmedForms.delete(form);
        return;
      }

      const variantId = getVariantIdFromForm(form);
      const message = getFuelMessage(variantId);

      if (!message) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      showPopup(message).then(() => {
        confirmedForms.add(form);

        setTimeout(() => {
          confirmedForms.delete(form);
        }, 2000);

        if (form.requestSubmit) {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    },
    true
  );
})();